<template>
  <form class="company-wall-form" novalidate @submit.prevent="handleSubmit">
    <STextInput
      v-model="zipCode"
      :aria-label="tr('main_site.company_wall.hero_form.zip_code_label')"
      autocomplete="postal-code"
      class="company-wall-form__input"
      name="zip_code"
      :placeholder="
        tr('main_site.company_wall.hero_form.zip_code_placeholder_alternative')
      "
    />
    <SButton
      class="company-wall-form__button"
      color="accent"
      suffix-icon="far fa-arrow-right"
      type="submit"
    >
      {{ tr("main_site.company_wall.hero_form.submit_button") }}
    </SButton>
  </form>
</template>

<script setup lang="ts">
import { navigateTo } from "#app";
import { ref } from "vue";

import { SButton } from "@solvari/common-fe";
import { STextInput } from "@solvari/components";
import { useI18nMainSiteCompanyWall } from "@solvari/translations";

const { tr } = useI18nMainSiteCompanyWall();

const props = defineProps<{
  formSubmitUrl: string | null;
}>();

const zipCode = ref("");

function handleSubmit() {
  if (!props.formSubmitUrl) {
    return;
  }

  void navigateTo(
    `${props.formSubmitUrl}?zip_code=${encodeURIComponent(zipCode.value)}`,
    { external: true },
  );
}
</script>

<style lang="postcss">
.company-wall-form {
  @apply flex w-auto flex-col gap-3;

  &__input {
    @apply w-full;
  }

  &__button {
    @apply h-12 w-full;
  }

  @screen 600 {
    @apply flex-row;

    &__button {
      @apply max-w-52;
    }
  }
}
</style>
